import { gql } from '@lcs/shared/api';

export const runClock = gql`
   query RunClock($params: ExecuteTilePostModelClockTileReportParametersInput!) {
      runClockTile(params: $params) {
         data {
            showDate
            timeZone
         }
         dashboardTileId
      }
   }
`;
